(() => {
 const render=()=>{
  const link=document.querySelector('[data-apo-skin-return]');
  if(!link)return;
  link.hidden=true;
  link.removeAttribute('href');
  if(new URLSearchParams(location.search).get('conseil')!=='peau')return;
  try{
   const state=JSON.parse(sessionStorage.getItem('apo-skin-return')||'null');
   if(!state?.products?.includes(Number(link.dataset.productId)))return;
   const url=new URL(state.url,location.origin);
   if(url.origin!==location.origin||!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections|pages)\/[a-z0-9-]+$/.test(url.pathname)||url.hash!=='#routine')return;
   if(url.pathname.includes('/collections/')&&url.searchParams.get('view')!=='apo-conseil-peau')return;
   link.href=url.pathname+url.search+url.hash;link.hidden=false;
  }catch{}
 };
 render();window.addEventListener('pageshow',render);
})();
